import { defineMessages } from 'react-intl'

export default defineMessages({
  awards: {
    id: 'common.actors.awards',
    defaultMessage: 'Notable Awards',
  },
  knownFor: {
    id: 'app.actorDetails.knownFor',
    defaultMessage: 'Known For',
  },
})
